import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postFsCreate = (params) => {
    return axios.post(`${backendHost}/api/admin/fs/create`, params);
};

export {
    postFsCreate
}